<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import { add, getCities, getDetails, update, del } from "@/api/tracker/cities";
import { getCity } from "@/api/system/city";
import cTable from "@/base/common/index";
export default {
  name: "trackerCities",
  components: {
    cTable
  },

  async mounted() {},
  methods: {},
  data() {
    return {
      methods: {
        list: getCities,
        add,
        getDetails,
        update,
        del,
        getCity
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: "40%"
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              group_name: [
                {
                  required: true,
                  type: "string",
                  message: "group_name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Maximum length 55",
                  trigger: "blur"
                }
              ],
              match_id: [
                {
                  required: true,
                  type: "array",
                  message: "match_id cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ group_name: 24 }, { match_id: 24 }],
          fields: [
            {
              key: "group_name",
              name: () => this.$t("group_name"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("group_name");
              }
            },
            {
              key: "match_id",
              name: () => this.$t("city_name"),
              component: "Select",
              bind: {
                multiple: true
              },
              config: {
                label: ({ row }) => row.code + "-" + row.title,
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("city_name");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCity")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              },
              id: 180
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("group_name"),
          key: "group_name",
          align: "left",
          width: 200
        },
        {
          name: () => this.$t("city_name"),
          key: "match_id",
          align: "left",
          showOverflow: false,
          render: (h, params) => {
            var newArr = [];
            params.row.match_name.forEach(item => {
              newArr.push(
                h(
                  "span",
                  {
                    class: "city-name"
                  },
                  item
                )
              );
            });
            return h(
              "div",
              {
                class: "city-div"
              },
              newArr
            );
          }
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              },
              id: 181
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
              id: 182
            }
          ],

          methods: {
            async updateFun({ row }) {
              console.log(row);
              let res = await this.handleRequestMethods("getDetails", {
                id: row.id
              });
              console.log("res", res);

              this.getModal("add").open(res.payload, function() {
                this.setTitle(this.$t("update"));
              });
            },
            async operationFun({ row }) {
              this.getModal("operation").open(
                {
                  packageId: row.id
                },
                function() {
                  this.setTitle(this.$t("operation"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("group_name") +
                  ":" +
                  row.group_name +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}
.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}
.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}
.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
